new WOW().init();
document.addEventListener('lazybeforeunveil', function (e) {
    var bg = e.target.getAttribute('data-bg');
    if (bg) {
        e.target.style.backgroundImage = 'url(' + bg + ')';
    }
});
$(document).ready(function () {
    BrowserDetection();
    if ($('.news-more').length) {
        $('.btn-share-icon').on('click', function () {
            $(this).parents('.news-teaser').parent().siblings().find('.news-more').removeClass('news-share--open');
            $(this).parent().toggleClass('news-share--open');
        });
    }
    // Navbar expand
    navbar_expand();
    //feature section Height
    feature_section();
    // Animation slider
    var animSlider = $('.anim-slider');
    if (animSlider.length) {
        if (animSlider.find('.anim-slide').length > 1) {
            animSlider.animateSlider({
                autoplay: true, //starts the autoplay 
                interval: 10,
                elemAnimate: true,
                animations: {
                    0: {
                        ".btn": {
                            show: "slideInRight",
                            hide: "slideOutLeft",
                            delayShow: "delay0-1s"
                        },
                        ".headline": {
                            show: "slideInDown",
                            hide: "slideOutUp",
                            delayShow: "delay1"
                        },
                        li: {
                            show: "fadeIn",
                            hide: "fadeOut",
                            delayShow: "delay0-1s"
                        }
                    },
                    1: {
                        ".btn": {
                            show: "slideInUp",
                            hide: "slideOutDown",
                            delayShow: "delay0-1s"
                        },
                        ".headline": {
                            show: "slideInRight",
                            hide: "slideOutLeft",
                            delayShow: "delay1"
                        },
                        li: {
                            show: "fadeIn",
                            hide: "fadeOut",
                            delayShow: "delay0-1s"
                        }
                    }
                }
            });
            $('.anim-arrows').show();
        } else {
            animSlider.show();
            $('.anim-arrows').hide();
        }
    }
    //Main top Spacing
    setTimeout(function () {
        $('.site-main').css('margin-top', header_height() - 2);
        $('.landing-slider-init').css('height', win_height() - header_height() + 2);
    }, 700);

    //Mobile Menu
    $('.menu-trigger').on('click', function () {
        $('body').toggleClass('menu--open');
        nav_height();
    });

    //mobile navigation
    $('.nav-arrow').on('click', function () {
        $(this).parent().siblings('li').removeClass('sub--open').find('ul').slideUp();
        $(this).parent().toggleClass('sub--open').find('ul').first().slideToggle();
    });
    // Go to bottom
    $('.scroll-down').bind('click', function (event) {
        $('html, body').stop().animate({
            scrollTop: ($(this).parents().next('section').offset().top - 55)
        }, 800);
        event.preventDefault();
    });
    // Go to top
    $(".goto-top").click(function () {
        $("html, body").animate({ scrollTop: 0 }, 1000);
        return false;
    });
    // Search Text Toggle
    $('.search-btn').click(function () {
        $('.navigation').toggleClass('search-show');
    });
    //project carousel
    var projectSlider = $('.project-slider-init');
    if (projectSlider.length) {
        if (projectSlider.find('.project-slide').length > 1) {
            projectSlider.owlCarousel({
                items: 3,
                nav: false,
                dots: true,
                loop: true,
                margin: 30,
                lazyLoad: true,
                autoplay: true,
                responsive: {
                    // breakpoint from 0 up
                    0: {
                        items: 1,
                    },
                    // breakpoint from 480 up
                    576: {
                        items: 2,
                    },
                    // breakpoint from 768 up
                    992: {
                        items: 3
                    }
                },
                onInitialize: function () {
                    if (projectSlider.find('.project-slide').length === 1) {
                        this.settings.loop = false;
                        this.settings.nav = false;
                    }
                }
            });
        } else {
            projectSlider.show();
        }
    }
    //project carousel
    var BestPropertySlider = $('.best-property-slider');
    if (BestPropertySlider.length) {
        if (BestPropertySlider.find('.best-property-slide').length > 1) {
            BestPropertySlider.owlCarousel({
                items: 3,
                nav: true,
                dots: false,
                loop: true,
                margin: 30,
                lazyLoad: true,
                autoplay: true,
                responsive: {
                    // breakpoint from 0 up
                    0: {
                        items: 1,
                    },
                    // breakpoint from 480 up
                    576: {
                        items: 2,
                    },
                    // breakpoint from 768 up
                    992: {
                        items: 3
                    }
                },
                onInitialize: function () {
                    if (BestPropertySlider.find('.best-property-slide').length === 1) {
                        this.settings.loop = false;
                        this.settings.nav = false;
                    }
                }
            });
        } else {
            BestPropertySlider.show();
        }
    }
    //testimonial carousel
    var testimonialSlider = $('.testimonial-slider-init');
    if (testimonialSlider.length) {
        if (testimonialSlider.find('.testimonial-slide').length > 1) {
            testimonialSlider.owlCarousel({
                items: 1,
                nav: true,
                dots: false,
                loop: true,
                autoplay: true,
                onInitialize: function () {
                    if (testimonialSlider.find('.testimonial-slide').length === 1) {
                        this.settings.loop = false;
                        this.settings.nav = false;
                    }
                }
            });
        } else {
            testimonialSlider.show();
        }
    }
    //postSlider
    var postSlider = $('.related-post-slider');
    if (postSlider.length) {
        if (postSlider.find('.related-post-slide').length > 1) {
            postSlider.owlCarousel({
                nav: true,
                dots: false,
                margin: 20,
                autoplay: true,
                loop: true,
                responsiveClass: true,
                responsive: {
                    0: {
                        items: 1
                    },
                    767: {
                        items: 3
                    },
                    991: {
                        items: 4
                    }
                }
            });
        } else {
            postSlider.show();
        }
    }
    if ($('.tabs').length) {
        /*Tab Element*/
        $(".tab_content").hide();
        $(".tab_content:first").show();
        /* if in tab mode */
        $("ul.tabs li").click(function () {

            $(".tab_content").hide();
            var activeTab = $(this).attr("rel");
            $("#" + activeTab).fadeIn();

            $("ul.tabs li").removeClass("active");
            $(this).addClass("active");

            $(".tab_drawer_heading").removeClass("d_active");
            $(".tab_drawer_heading[rel^='" + activeTab + "']").addClass("d_active");

        });
        /* if in drawer mode */
        $(".tab_drawer_heading").click(function () {

            $(".tab_content").hide();
            var d_activeTab = $(this).attr("rel");
            $("#" + d_activeTab).fadeIn();

            $(".tab_drawer_heading").removeClass("d_active");
            $(this).addClass("d_active");

            $("ul.tabs li").removeClass("active");
            $("ul.tabs li[rel^='" + d_activeTab + "']").addClass("active");
        });
        /* Extra class "tab_last" to add border to right side of last tab */
        $('ul.tabs li').last().addClass("tab_last");
    }

    //Light Box
    if ($('.lightbox').length) {
        $('.lightbox').fancybox();
    }
});
$(window).on('resize', function () {
    nav_height();
    //feature section Height
    feature_section();
    //Main top Spacing
    setTimeout(function () {
        $('.site-main').css('margin-top', header_height() - 2);
        $('.landing-slider-init').css('height', win_height() - header_height() + 2);
    }, 700);
    /*isotope_masonry Function*/
    isotope_masonry();
});
$(window).on('load', function () {
    //feature section Height
    feature_section();
    //Preloader JS code
    setTimeout(remove_loader, 300);

    /*isotope_masonry Function*/
    isotope_masonry();
    if ($('.sorting-btn').length) {
        $('.button-switch').on('click', function () {
            var sortValue = $(this).attr('data-sort-value');
            $(this).toggleClass("on");
            var direction = $(this).attr('data-sort-direction');

            /* convert it to a boolean */
            var isAscending = (direction === 'asc');
            var newDirection = (isAscending) ? 'desc' : 'asc';

            /* pass it to isotope */
            newsGrid.isotope({
                sortBy: sortValue,
                sortAscending: isAscending
            });
            $(this).attr('data-sort-direction', newDirection);
        });
    }
});
var stickyOffset = $('header').height();
var previousScroll = 0;
$(window).scroll(function () {
    var scroll = $(window).scrollTop();
    // Fixed Menu
    if (scroll >= stickyOffset) {
        $('body').addClass('fixed-header');
    } else {
        $('body').removeClass('fixed-header');
    }

    /* for go to top arrow */
    var currentScroll = $(this).scrollTop();
    if (currentScroll > previousScroll) {
        if (scroll >= stickyOffset + 100) {
            $('.goto-top').addClass('visible');
        }
    } else {
        $('.goto-top').removeClass('visible');
    }
    // code for counter 
    if ($('.about-teaser-counter').length) {
        var count_scroll = $('.about-teaser-counter').offset().top - win_height();
        if (scroll > count_scroll) {
            $('.animation-counter').each(function () {
                init_odometer(this);
            });
        }
    }
    // code for counter 
    if ($('.employee-counter-teaser').length) {
        var count_scroll = $('.employee-counter-teaser').offset().top - win_height();
        if (scroll > count_scroll) {
            $('.animation-counter').each(function () {
                init_odometer(this);
            });
        }
    }
});

function nav_height() {
    if (win_width() > 991) {
        $('.navigation').css('height', 'auto');
        $('.navigation').css('margin-top', 0);
    } else {
        $('.navigation').css('height', win_height() - header_height() + 1);
        $('.navigation').css('margin-top', header_height() - 1);
    }
}
function win_height() {
    return $(window).outerHeight();
}
function win_width() {
    return $(window).width();
}
function header_height() {
    return $('header.page').outerHeight();
}
/*Navbar Expand Function*/
function navbar_expand() {
    if ($(window).width() >= 992) {
        $('.has-sub-menu').hover(function () {
            $(this).children('.sub-menu-list').toggleClass('has-menu-open');
        });
    } else {
        $('.menu-toggle-ico').click(function () {
            $(this).toggleClass('rotate-ico');
            $(this).siblings('.sub-menu-list').toggleClass('has-menu-open');
            $(this).siblings('.mega-sub-menu').toggleClass('has-menu-open');
            $(this).siblings('.grid-menu').toggleClass('has-menu-open');
        });
    }
}
/*Odometer Function*/
function init_odometer(el) {
    if ($('.animation-counter-odometer', el).size() == 0)
        return;
    var odometer = $('.animation-counter-odometer', el).get(0);
    var format = $(el).closest('.animation-counter-box').data('number-format');
    format = format ? format : '(ddd).ddd';
    var od = new Odometer({
        el: odometer,
        value: $(odometer).text(),
        format: format
    });
    od.update($(odometer).data('to'));
}
/*isotope_masonry Function*/
function isotope_masonry() {
    //portfolio Isotope plugins initialize
    if ($('.news-grid').length) {
        newsGrid = $('.news-grid').isotope({
            itemSelector: '.news-grid-item',
            layoutMode: "packery",
            getSortData: {
                dateby: '.news-date',
                filename: '.news-title',
            }
        });
        var img = $('img');
        newsGrid.imagesLoaded(function () {
            img.load(function () {
                newsGrid.isotope('layout');
            });
        });

        // filter items on button click
        $('.js-filter').on('click', 'button', function () {
            var filterValue = $(this).attr('data-filter');
            newsGrid.isotope({
                filter: filterValue
            });
            $('.js-filter button').removeClass('is-active');
            $(this).addClass('is-active');
        });
    }
}
/* Feaure Property section */
function feature_section() {
    setTimeout(function () {
        var featuredProperties = $('.featured-properties-wrapper').outerHeight();
        if ($('.featured-properties-wrapper').length) {
            $('.featured-properties-section').css('height', featuredProperties - 300);
        }
    }, 700);
}
/* Preloader */
function remove_loader() {
    $('.preloader').hide();
}
function BrowserDetection() {
    if (navigator.userAgent.match(/msie/i) || navigator.userAgent.match(/trident/i)) {
        $("body").addClass("msie");
    }
}
